import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import baseURL from "./baseURL/BaseURL";
import { useDispatch } from "react-redux";
import { authSliceActions } from "../../redux/slices/authSlice";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const LoginViaOTP = () => {
  const [email, setEmail] = useState("");
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      toast.error("Please enter a valid email address");
      setIsLoading(false);
      return;
    }

    try {
      const response = await baseURL.post("/otp/send", { email });

      if (response.status === 200) {
        toast.success(response.data.message);
        dispatch(authSliceActions.getEmailVal(email));

        setTimeout(() => {
          navigate("/setotp");
        }, 2000);
      } else {
        toast.error(`Unexpected response: ${response.status}`);
      }
    } catch (error) {
      const errorMsg =
        error.response?.data?.error || "Failed to send OTP. Please try again.";
      toast.error(errorMsg);
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <>
      <ToastContainer />
      <div className="min-h-screen bg-gray-100 flex items-center justify-center px-4 py-8 font-serif">
        <div className="bg-white shadow-xl rounded-xl w-full max-w-md p-8 space-y-6">
          <div className="text-center">
            <h2 className="text-3xl font-bold text-gray-800 font-serif">
              Login
            </h2>
            <p className="text-gray-500 mt-2">
              Enter Your Registered Email Address
            </p>
          </div>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="relative">
              <label
                htmlFor="email"
                className="block text-sm font-medium text-gray-700 mb-2"
              >
                Enter Email
              </label>
              <div className="flex items-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="absolute left-3 text-gray-400"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                  <polyline points="22,6 12,13 2,6" />
                </svg>
                <input
                  type="email"
                  name="userEmail"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Example@gmail.com"
                  required
                  className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-md focus:outline-none transition duration-300"
                />
              </div>
            </div>

            <button
              type="submit"
              disabled={isLoading}
              className="w-full bg-[#730000] text-white py-2 rounded-md hover:bg-[#730000] transition duration-300 ease-in-out transform hover:scale-102 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50"
            >
              {isLoading ? "Verifying..." : "Verify OTP"}
            </button>
          </form>
        </div>
      </div>
    </>
  );
};

export default LoginViaOTP;
